module.exports = __webpack_public_path__ + "img/+.1f23cb72.svg";